import styled from 'styled-components';
import { MenuItemTemplate } from './MenuItemTemplate';
import { isBrandAC, isBrandAP, isBrandDS, isBrandOV, isMarketGB } from '../../constants/main';
import { StylesAC } from './Styles.AC';
import { StylesAP } from './Styles.AP';
import { StylesDS } from './Styles.DS';
import { StylesOV } from './Styles.OV';
import { StylesOV_GB } from './Styles.OV.GB';

export const MenuItem = styled(MenuItemTemplate)`
    ${isBrandAC && StylesAC};
    ${isBrandAP && StylesAP};
    ${isBrandDS && StylesDS};
    ${isBrandOV && (isMarketGB ? StylesOV_GB : StylesOV)}
`;
